import React from 'react';

interface TermsAndConditionsComponentProps {
    qrId: string;
    shopName: string;
    carBrand: string;
    carModel: string;
    carColor: string;
    carPlate: string;
    onAccept: () => void;
    loading?: boolean;
}

const TermsAndConditionsComponent: React.FC<TermsAndConditionsComponentProps> = ({
    qrId,
    shopName,
    carBrand,
    carModel,
    carColor,
    carPlate,
    onAccept,
    loading = false
}) => {
    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow">
                        <div className="card-body">
                            <h2 className="card-title text-center mb-4">Términos y Condiciones</h2>

                            <div className="mb-4">
                                <h5>Información del Servicio</h5>
                                <p><strong>QR ID:</strong> {qrId}</p>
                                <p><strong>Establecimiento:</strong> {shopName}</p>
                            </div>

                            <div className="mb-4">
                                <h5>Información del Vehículo</h5>
                                <p><strong>Marca:</strong> {carBrand}</p>
                                <p><strong>Modelo:</strong> {carModel}</p>
                                <p><strong>Color:</strong> {carColor}</p>
                                <p><strong>Placa:</strong> {carPlate}</p>
                            </div>

                            <div className="alert alert-info" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <h6 className="fw-bold text-center">TÉRMINOS Y CONDICIONES DE USO DEL SERVICIO DE APOLO VALET PARKING</h6>
                                <p className="text-center small">(Mussero SRL – Aplicación Móvil y Sitio Web)</p>
                                <p className="text-center small mb-3"><strong>Última actualización: 2025</strong></p>
                                
                                <p className="small">
                                    Al utilizar la aplicación móvil, el sitio web o cualquier servicio de Apolo Valet Parking operado 
                                    por Mussero SRL, el usuario acepta de manera expresa los presentes Términos y Condiciones. Si el usuario no está de acuerdo con alguna de las disposiciones aquí 
                                    establecidas, debe abstenerse de utilizar el servicio.
                                </p>

                                <h6 className="mt-3 fw-bold">1. Naturaleza del Servicio</h6>
                                <p className="small">
                                    Apolo Valet Parking es un servicio de estacionamiento asistido provisto por Mussero SRL 
                                    dentro de la República Dominicana.
                                </p>
                                <p className="small">
                                    El servicio NO es un servicio de seguridad, custodia, vigilancia ni transporte de vehículos.
                                </p>
                                <p className="small">
                                    El usuario reconoce que al entregar su vehículo a un valet, acepta estas condiciones en su totalidad.
                                </p>

                                <h6 className="mt-3 fw-bold">2. Registro de Usuarios</h6>
                                <p className="small">
                                    Los usuarios pueden crear una cuenta en la aplicación mediante correo electrónico y/o número de teléfono.
                                </p>
                                <p className="small">
                                    No existen restricciones de edad para el uso de la aplicación; sin embargo, el usuario debe 
                                    tener capacidad legal para aceptar estos términos.
                                </p>

                                <h6 className="mt-3 fw-bold">3. Política de Responsabilidad</h6>
                                <p className="small">
                                    La responsabilidad del servicio digital y presencial es idéntica a la política expresada en el 
                                    ticket físico utilizado en todos los establecimientos asociados.
                                </p>

                                <h6 className="mt-3 fw-bold">3.1 Exclusión de responsabilidad general</h6>
                                <p className="small">En NINGÚN caso Mussero SRL asume responsabilidad por:</p>
                                <ul className="small">
                                    <li>Fuego, robo o daños por causa fortuita o fuerza mayor, de cualquier especie. 
                                        Ejemplos: si el vehículo una vez estacionado es chocado por un tercero, le cae una 
                                        rama, alguien vandaliza el vehículo, o cualquier otro daño ajeno al personal.</li>
                                    <li>Daños, lesiones o accidentes causados por fallos mecánicos del vehículo, 
                                        incluyendo pero no limitado a:
                                        <ul>
                                            <li>Frenos defectuosos</li>
                                            <li>Fallas eléctricas</li>
                                            <li>Fallas de motor u otros equipos</li>
                                        </ul>
                                    </li>
                                    <li>Pérdida o robo de accesorios o artículos dentro del vehículo, a menos que haya 
                                        evidencia y se demuestre que un empleado de Apolo Valet Parking estuvo directamente 
                                        involucrado.</li>
                                </ul>

                                <h6 className="mt-3 fw-bold">3.2 Vehículo bajo custodia del valet</h6>
                                <p className="small">Mussero SRL solo asume responsabilidad si:</p>
                                <ol className="small">
                                    <li>El valet está directamente involucrado en el incidente, y</li>
                                    <li>El cliente presenta evidencia clara (fotos, videos, registros), y</li>
                                    <li>El reclamo se realiza antes de que el vehículo salga del recinto.</li>
                                </ol>
                                <p className="small">De no cumplirse estas condiciones, no existe responsabilidad alguna.</p>

                                <h6 className="mt-3 fw-bold">4. Reclamos</h6>
                                <ul className="small">
                                    <li>Todo reclamo debe realizarse antes de retirar el vehículo del establecimiento.</li>
                                    <li>Si el cliente sale del recinto, se asume que el servicio fue recibido satisfactoriamente.</li>
                                    <li>No se aceptarán reclamos posteriores bajo ninguna circunstancia.</li>
                                </ul>

                                <h6 className="mt-3 fw-bold">5. Objetos Personales</h6>
                                <p className="small">
                                    Mussero SRL no es responsable por artículos olvidados, visibles o no, dentro del interior del 
                                    vehículo, excepto cuando exista evidencia directa y clara de que un empleado estuvo 
                                    involucrado en su desaparición.
                                </p>

                                <h6 className="mt-3 fw-bold">6. Normas para Conductores y Supervisores</h6>
                                <p className="small">Los empleados deben cumplir estrictamente con las políticas internas de Mussero SRL, incluyendo:</p>
                                <ul className="small">
                                    <li>Prohibición absoluta de consumir alcohol o sustancias durante el turno.</li>
                                    <li>Prohibición de utilizar el vehículo del cliente para fines personales.</li>
                                    <li>Prohibición de transportar terceros.</li>
                                    <li>Manejo del vehículo únicamente para estacionamiento y devolución.</li>
                                    <li>Respeto a clientes y compañeros.</li>
                                    <li>Uso obligatorio de la aplicación, tickets o medios oficiales para recibir y entregar vehículos.</li>
                                </ul>
                                <p className="small">Los supervisores tienen acceso únicamente a:</p>
                                <ul className="small">
                                    <li>Nombre del cliente</li>
                                    <li>Foto del vehículo</li>
                                    <li>Número de placa</li>
                                </ul>
                                <p className="small">Los valets no tienen acceso a datos personales del cliente.</p>

                                <h6 className="mt-3 fw-bold">7. Privacidad y Manejo de Datos</h6>
                                <p className="small">La aplicación puede recopilar:</p>
                                <ul className="small">
                                    <li>Ubicación en tiempo real del valet al inicio de su turno</li>
                                    <li>Foto del vehículo</li>
                                    <li>Ubicación del vehículo al ser estacionado</li>
                                    <li>Nombre del usuario y placa del vehículo</li>
                                </ul>
                                <p className="small">El vehículo NO es rastreado mientras es conducido por el valet.</p>
                                <p className="small">Los datos solo pueden compartirse con:</p>
                                <ul className="small">
                                    <li>Mussero SRL (Apolo Valet Parking)</li>
                                    <li>Autoridades en caso de incidentes o requerimientos legales</li>
                                </ul>
                                <p className="small">No se comparten datos con establecimientos comerciales.</p>

                                <h6 className="mt-3 fw-bold">8. Pagos</h6>
                                <p className="small">
                                    En algunos establecimientos, el servicio puede ser gratuito; en otros, puede requerir un pago 
                                    directo en efectivo.
                                </p>
                                <p className="small">La aplicación mostrará esta información cuando aplique.</p>

                                <h6 className="mt-3 fw-bold">9. Suspensión de Cuentas</h6>
                                <p className="small">Mussero SRL puede suspender o desactivar cuentas de clientes, valets o supervisores por:</p>
                                <ul className="small">
                                    <li>Mal comportamiento</li>
                                    <li>Incumplimiento de normas</li>
                                    <li>Fraude</li>
                                    <li>Reportes confirmados múltiples</li>
                                </ul>

                                <h6 className="mt-3 fw-bold">10. Limitación de Modificación de Responsabilidad</h6>
                                <p className="small">
                                    Ningún empleado, supervisor o valet tiene la facultad de variar, ampliar o modificar estos 
                                    términos ni la responsabilidad de Mussero SRL.
                                </p>
                                <p className="small">Cualquier intento carece de validez.</p>

                                <h6 className="mt-3 fw-bold">11. Jurisdicción</h6>
                                <p className="small">Estos Términos se rigen por las leyes de la República Dominicana.</p>
                                <p className="small">Cualquier disputa deberá resolverse conforme a la legislación vigente.</p>

                                <h6 className="mt-3 fw-bold">12. Contacto Oficial</h6>
                                <p className="small">Para cualquier duda, incidencia o reclamo previo a salir del establecimiento, el usuario puede contactar a:</p>
                                <ul className="small">
                                    <li>Oficina Apolo Valet Parking: +1 (809) 910-1905</li>
                                    <li>Supervisor 1: +1 (809) 613-6116</li>
                                    <li>Supervisor 2: +1 (809) 910-6935</li>
                                </ul>

                                <h6 className="mt-3 fw-bold">13. Aceptación</h6>
                                <p className="small">
                                    El uso de la aplicación, del sitio web o del servicio presencial constituye la aceptación total y 
                                    absoluta de estos Términos y Condiciones.
                                </p>
                            </div>

                            <div className="text-center">
                                <button
                                    className="btn btn-primary btn-lg"
                                    onClick={onAccept}
                                    disabled={loading}
                                >
                                    {loading ? 'Procesando...' : 'Aceptar Términos y Condiciones'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditionsComponent;
